module.exports = __webpack_public_path__ + "static/img/home_banner.e53b6aab.png";